import notificationAudio from "../../src/assets/audios/notification.mp3";

// Persist the live-audio Set on window so HMR / hot reloads can still
// reach orphaned audio elements created by a previous module instance.
const liveAudios =
  (typeof window !== "undefined" && window.__notifLiveAudios) || new Set();
if (typeof window !== "undefined") {
  window.__notifLiveAudios = liveAudios;
}

// Aggressively tear down an audio element. Each step is in its own
// try/catch so a DOMException from an in-flight play() promise doesn't
// skip the remaining cleanup steps.
const hardKill = (audio) => {
  liveAudios.delete(audio);
  try { audio.muted = true; } catch (e) {}
  try { audio.volume = 0; } catch (e) {}
  try { audio.pause(); } catch (e) {}
  try { audio.currentTime = 0; } catch (e) {}
  try { audio.src = ""; } catch (e) {}
  try { audio.removeAttribute("src"); } catch (e) {}
  try { audio.load(); } catch (e) {}
};

export const playMessageSound = () => {
  stopMessageSound();

  const audio = new Audio(notificationAudio);
  liveAudios.add(audio);
  audio.addEventListener("ended", () => liveAudios.delete(audio));

  const p = audio.play();
  audio.__playPromise = p;
  if (p && typeof p.catch === "function") {
    p.catch(() => liveAudios.delete(audio));
  }
};

export const stopMessageSound = () => {
  if (liveAudios.size === 0) return;

  for (const audio of Array.from(liveAudios)) {
    // Synchronous full kill — silence is immediate (muted/volume/pause)
    // because these properties apply even while play() is still resolving.
    hardKill(audio);
    // Belt-and-suspenders: re-kill once play() settles, in case the
    // browser ignored the synchronous pause due to an in-flight promise.
    Promise.resolve(audio.__playPromise)
      .then(() => hardKill(audio))
      .catch(() => hardKill(audio));
  }
};
